export default class ScanDetector {
    private static readonly QUIET_PERIOD_MS = 60;

    private quietTimer: number = null;
    private currentValue: string = '';

    constructor(private readonly onScanComplete: (value: string) => void) {
    }

    onInput(value: string): void {
        const isBurstInsert = value.length - this.currentValue.length > 1;
        this.currentValue = value;

        this.clearQuietTimer();

        if (isBurstInsert) {
            this.quietTimer = window.setTimeout(() => {
                const scannedValue = this.currentValue;
                this.clearQuietTimer();
                this.onScanComplete(scannedValue);
                this.currentValue = "";
            }, ScanDetector.QUIET_PERIOD_MS);
        }
    }

    reset(): void {
        this.clearQuietTimer();
        this.currentValue = '';
    }

    private clearQuietTimer(): void {
        if (this.quietTimer != null) {
            window.clearTimeout(this.quietTimer);
            this.quietTimer = null;
        }
    }
}
